// extracted by mini-css-extract-plugin
module.exports = {"sb4ns5w":"sb4ns5w","icon":"icon","actionCopy":"actionCopy","read-now":"read-now","saved":"saved","saving":"saving","pbl8oim":"pbl8oim","popoverLink":"popoverLink"};